/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Link } from "gatsby";
import VisuallyHidden from "../VisuallyHidden";
import Nexo from "../../../static/svg/nexo.svg";
import PropsNav from "../../types/PropsNav";

const Nav = (props: PropsNav) => {
  const { prev, next, color } = props;

  const LinkStyle = (direction: "right" | "left"): Record<string, any> => {
    return {
      color: color,
      position: "relative",
      display: "inline-block",
      paddingBottom: "12px",
      textDecoration: "none",
      fontFamily: "'Zilla Slab', serif",
      fontSize: "1.2rem",
      fontWeight: 500,
      "&::before": {
        background: color,
        position: "absolute",
        content: "''",
        bottom: 0,
        height: "3px",
        right: direction === "right" ? "100%" : 0,
        left: direction === "right" ? 0 : "100%",
        transitionProperty: direction,
        transitionDuration: "0.3s",
      },
      "&:hover::before, &:focus::before, &:active::before": {
        [direction]: 0,
      },
    };
  };

  return (
    <nav
      aria-label="Main"
      css={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
      }}
    >
      <Link css={LinkStyle("left")} to={prev ? `/${prev.slug}/` : "/"}>
        <span aria-hidden={true}>{"— "}</span>Prev
      </Link>
      <Link
        to="/"
        css={{
          display: "inline-block",
          width: 120,
          backgroundColor: "white",
          stroke: color,
          strokeWidth: "1%",
          fill: color,
          padding: 10,
          transitionDuration: "0.3s",
          transitionProperty: "background-color fill stroke",
          "&:hover, &:focus, &:active": {
            backgroundColor: color,
            fill: "white",
            stroke: "white",
          },
        }}
      >
        <VisuallyHidden>Front page</VisuallyHidden>
        <Nexo css={{ width: "100%" }} />
      </Link>
      <Link css={LinkStyle("right")} to={next ? `/${next.slug}/` : "/"}>
        Next<span aria-hidden={true}>{" —"}</span>
      </Link>
    </nav>
  );
};

export default Nav;
